// extracted by mini-css-extract-plugin
export default {"ActionTitle":"ActionTitleStyle_ActionTitle__jhqoB"};